import { createSelector } from '@reduxjs/toolkit';
import { getContactsAsUsers } from './get-contacts-as-users';
import { getCurrentUserEmail } from '../session';

import { isCurrentUser } from '../utilities/isCurrentUser';

export const currentContactUuid = createSelector(
  getContactsAsUsers,
  getCurrentUserEmail,
  function (contacts, currentUserEmail) {
    const contact = contacts.filter((e) => isCurrentUser(e.email, currentUserEmail));
    if (contact.length) {
      return contact[0].uuid;
    }
    return undefined;
  },
);
